import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./testimonials.css";
import { FaStar } from "react-icons/fa6";
import Full2 from "./Full2";

export const Testimonials = (props) => {
  const history = useHistory();
  const location = useLocation();
  const isServicePage = location.pathname.startsWith('/service');

  const handleDevisClick = (e) => {
    e.preventDefault();
    if (isServicePage) {
      history.push('/#Devis');
      setTimeout(() => {
        const element = document.querySelector('#Devis');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);
    } else {
      const element = document.querySelector('#Devis');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-title text-center">
          <h2 className="testimonials-title">Avis de nos clients</h2>
          <div className="title-underline"></div>
        </div>

        {/* Testimonials Grid */}
        <div className="row testimonials-grid">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4 col-sm-6" style={{display:'flex',justifyContent:'center'}}>
                  <div className="testimonial-card review-card">
                    <div className="decor-icon">
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 448 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"></path>
                      </svg>
                    </div>
                    <div className="testimonial-avatar">
                      <img src={d.img} alt={d.name} />
                    </div>

                    <p className="testimonial-text">{d.text}</p>
                    <p
                      className="font13"
                      style={{
                        color: '#fbbf24',
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '4px',
                        fontSize: '20px',
                        marginTop: '8px',
                      }}
                    >
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      <FaStar />
                    </p>

                    <div className="testimonial-meta">— {d.name}</div>
                  </div>
                </div>
              ))
            : "Chargement..."}
        </div>
<br/>
<br/>
<br/>
<div className="d_non">
                <div className="" style={{display:'flex',justifyContent:'center'}}>

                <a
                  href={isServicePage ? "/#Devis" : "#Devis"}
                  className=" page-scroll impr"
                  style={{fontSize:'18px',paddingTop:'16px'}}
                  onClick={handleDevisClick}
                >
Demande Devis
                </a>
                  <div style={{ marginLeft: "18px" }}>
                                            <a href="#contact2" className="impr2" >

                    <Full2 title="Contactez-nous" className='btn'  border />
                                            </a>

                  </div>


                </div>
</div>


<div className="d_yes">
                <div className="" style={{display:'flex',justifyContent:'center'}}>

                <a
                  href={isServicePage ? "/#Devis" : "#Devis"}
                  className=" page-scroll impr nj"
                  style={{fontSize:'18px',paddingTop:'16px'}}
                  onClick={handleDevisClick}
                >
Demande Devis
                </a>
                                </div>
                <div className="" style={{display:'flex',justifyContent:'center',marginTop:'25px'}}>

                  <div style={{ }}>
                                            <a href="#contact2" className="impr2 nj" >

                    <Full2 title="Contactez-nous" className='btn'  border />
                                            </a>

                  </div>
                  </div>


</div>
<br/>
<br/>
      </div>
    </section>
  );
};
